import React, { useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import { loginUser } from "../../services/api/authentication";


import User from "../../models/User";

import { APP_URL } from "../../util/constants/APP_URL";

import { useDispatch } from 'react-redux';
import asgImage from '../../assets/images/ASG.png';
import misionImage from '../../assets/images/MISION.png';
import femaleMaleImage from '../../assets/images/female_male.png';
import loadingIcon from "../../assets/images/loading.gif";
import { loginSuccess } from '../../services/auth';


type UserFormInputs = {
    dni: string
    password: string
}

const Login = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const { register, handleSubmit, formState: { isValid } } = useForm<UserFormInputs>({
        mode: 'onChange'
    });

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('')

    const redirectoTo = (url: string) => {
        navigate(url)
    }

    const onSubmit: SubmitHandler<UserFormInputs> = async (data) => {
        setError('')
        setIsLoading(true);

        const newUser = new User({
            dni: data.dni,
            password: data.password
        });

        if (newUser.validateLoginFields()) {
            await loginUser(newUser)
                .then(result => {
                    if (result.status) {
                        dispatch(loginSuccess(result))
                        setIsLoading(false);
                        navigate(result.user.instructor ? APP_URL.DASHBOARD.HOME : APP_URL.QUIZ.SELECT)
                    }
                    else {
                        setError(result.error.message)
                    }
                })
                .catch(err => {
                    console.log({ err })
                })
                .finally(() => {
                    setIsLoading(false);
                })
        }
    };

    return (
        <>
            {
                isLoading && (
                    <div className="loading_all_page">
                        <img src={loadingIcon} alt="loading" width="120" height="120" />
                    </div>
                )
            }
            <section className="background-form">
                {
                    isLoading &&
                    (
                        <div className="loading_all_page">
                            <img src={loadingIcon} alt="loading" width="120" height="120" />
                        </div>
                    )
                }
                <div className="image-section">
                    <div>
                        <div>
                            <img src={femaleMaleImage} alt="mision" />
                        </div>
                    </div>
                </div>
                <div className="width-full height-full">
                    <div className="pt-8-per left-0 right-0">
                        <div className="bar-asg">
                            <div>
                                <img src={misionImage} alt="mision" />
                                <img src={asgImage} alt="ASG" />
                            </div>
                        </div>
                    </div>
                    <div className="width-full flex justify-content-center align-center relative">
                        <div className="inputs-section login-inputs">
                            <div>
                                <p className="title ft-EricssonGA628">INICIAR SESIÓN</p>
                                <div className="form">
                                    <form>
                                        <div className="form-section">
                                            <input
                                                type="text"
                                                placeholder="Escribe tu DNI"
                                                {...register("dni", {
                                                    required: "DNI es obligatorio.",
                                                    minLength: {
                                                        value: 8,
                                                        message: "El DNI debe tener al menos 8 dígitos."
                                                    }
                                                })}
                                                onKeyDown={(e) => {
                                                if (e.key === " ") e.preventDefault();
                                                }}
                                            />
                                        </div>
                                        <div className="form-section">
                                            <input
                                                type="text"
                                                placeholder="Escribe tu contraseña"
                                                {...register("password", {
                                                    required: "La contraseña es requerida"
                                                })}
                                                onKeyDown={(e) => {
                                                    if (e.key === " ") e.preventDefault();
                                                }}
                                            />
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div className="flex justify-content-center button-submit flex-column align-items-center gap-3">
                                <button onClick={handleSubmit(onSubmit)} disabled={!isValid}>
                                    <span className="ft-EricssonGA628">Iniciar</span>
                                    {
                                        isLoading &&
                                        <img src={loadingIcon} alt="loading" width="35" height="35" />
                                    }
                                </button>
                                <p className="pie-title ft-EricssonGA628" onClick={() => redirectoTo(APP_URL.AUTHENTICATION.RECOVERY)}>Recuperar contraseña</p>
                                <p className="pie-title ft-EricssonGA628 pointer subtitle-home" onClick={() => redirectoTo(APP_URL.AUTHENTICATION.REGISTER)}>Regístrese aquí</p>
                            </div>
                            <div className="error-section">
                                <p className="ft-EricssonGA628">{error}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Login;